module.exports = __webpack_public_path__ + "static/img/function-7.9ca2fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/function-7.png
// module id = Bgle
// module chunks = 0